export const APP = "/app";
export const WELCOME = "/";
export const HOME = "/app/home";
export const MAIN = "/app/main";
export const PRODUCT = "/app/product";
